import {
  FETCH_CIVIL_MATERIAL_ANALYSIS,
  FETCH_CARPENTRY_MATERIAL_ANALYSIS,
} from '../constants/actionTypes';

function boqCarpentryMaterialAnalysisReducer(
  state = {
    cost: 0,
    items: [],
    hasError: false,
    isFetchingFromAPI: false,
  },
  action,
) {
  switch (action.type) {
    case FETCH_CARPENTRY_MATERIAL_ANALYSIS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

function boqCivilMaterialAnalysisReducer(
  state = {
    cost: 0,
    items: [],
    hasError: false,
    isFetchingFromAPI: false,
  },
  action,
) {
  switch (action.type) {
    case FETCH_CIVIL_MATERIAL_ANALYSIS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export { boqCarpentryMaterialAnalysisReducer, boqCivilMaterialAnalysisReducer };
